// src/modules/fire/Quotation/utils/mapCalculationPayload.ts

import { globalRemoveMaskReal2 } from "../../../../shared/utils";
import { FireQuotePayload } from "../../quote/components/types";

export interface BuildCalculationPayloadParams {
	clientId: string;
	companyId: string;

	// 🔹 agora incluímos também o propertyType (risk group / tipo de imóvel)
	propertyType: string;

	occupationId: string;
	assistanceId: string | null;

	brokerageId: number | string;

	pc_predial: number;
	pc_content: number;
	prolabore_percent_amount: number;
	brokerage_comission_percent_amount: number;

	// no cálculo = sempre 0 (endpoint não deve usar este valor)
	insurance_prize: number;

	flag_rent_changed: boolean;

	coverages: any[];
}

export function mapFormToCalculationPayload(form: any, ctx: BuildCalculationPayloadParams): FireQuotePayload {
	const {
		clientId,
		companyId,
		propertyType,
		occupationId,
		assistanceId,
		brokerageId,
		pc_predial,
		pc_content,
		prolabore_percent_amount,
		brokerage_comission_percent_amount,
		flag_rent_changed,
		coverages,
	} = ctx;

	// 🔹 garante string para o globalRemoveMaskReal2
	const rent_value = Number(globalRemoveMaskReal2(String(form?.rent_value ?? "0")));

	return {
		clientId: clientId,
		insurance_companiesId: companyId,
		occupationId,
		assistanceId: assistanceId ?? "",

		// 🔹 backend reclamou que precisa ser string
		brokerageId: String(brokerageId ?? ""),

		rent_value,
		insurance_prize: 0, // Sempre 0 no cálculo, endpoint não deve usar este valor

		brokerage_comission_percent_amount,
		prolabore_percent_amount,
		pc_predial,
		pc_content,

		validity_start: form?.validity_start ?? new Date().toISOString(),
		monthly_validity: Number(form?.monthly_validity ?? 12),

		flag_rent_changed,

		coverages: (coverages ?? []).map((c) => ({
			id: c.id ?? c.coverageId,
			coverage_value: typeof c.coverage_value === 'number'
				? c.coverage_value
				: Number(globalRemoveMaskReal2(String(c.coverage_value ?? c.value ?? "0"))),
		})),
	};
}
